import React, { useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { AzotoAplicadoForm } from "./azotoaplicado";
import { Theme } from "@mui/material/styles";
import { AguaRegaForm } from "./agua_de_rega";
import { IAguaDeRega, IAzotoAplicado, ICabecalho5D, IFertilizacaoOrganica } from "../../../Interfaces/cadernos/caderno5/interfaces5D";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { CabecalhoForm } from "./cabecalho";
import { FertilizacaoOrganicaForm } from "./fertilizacao_organica";
import { FilterByData } from "../../../Func_genericas/filter_by_data";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(0),
        },
        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
    })
);

export default function RegAtividadesFO() {

    const classes = useStyles();

    const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho5D | undefined>();
    const [total_quant3, set_total_quant3] = React.useState<number>(0);
    const [obj_organica, set_obj_organica] = useState<IFertilizacaoOrganica | undefined>();

    const [rowsAzoto, setRowsAzoto] = useState<IAzotoAplicado[]>([]);
    const [rowsAzoto_filtrada, setRowsAzoto_filtrada] = useState<IAzotoAplicado[]>([]);
    const [rowsAgua, setRowsAgua] = useState<IAguaDeRega[]>([]);
    const [rowsAgua_filtrada, setRowsAgua_filtrada] = useState<IAguaDeRega[]>([]);


    return (
        <div className={classes.root}>
            <CadernoLayout title="5D - Registo das Atividades de fertilização Orgânica" />
            <main className={classes.contents}>
                <div className={classes.toolbars} />
                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>
                <FilterByData
                    listas={[
                        {
                            lista_original: rowsAzoto,
                            set_lista_filtrada: setRowsAzoto_filtrada,
                            campoData: "data_aplica",
                        },
                        {
                            lista_original: rowsAgua,
                            set_lista_filtrada: setRowsAgua_filtrada,
                            campoData: "data_rega",
                        },


                    ]}
                />


                <CabecalhoForm
                    obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
                    set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
                />
                {
                    obj_anexo_cabecalho_selecionado !== undefined ?
                        <>
                            <AzotoAplicadoForm
                                cabecalho={obj_anexo_cabecalho_selecionado}
                                set_obj_organica={set_obj_organica}
                                set_total_quant3={set_total_quant3}
                                total_quant3={total_quant3}
                                rowsAzoto={rowsAzoto}
                                rowsAzoto_filtrada={rowsAzoto_filtrada}
                                setRowsAzoto={setRowsAzoto}
                                setRowsAzoto_filtrada={setRowsAzoto_filtrada}
                            />

                            <AguaRegaForm
                                cabecalho={obj_anexo_cabecalho_selecionado}
                                rowsAgua={rowsAgua}
                                rowsAgua_filtrada={rowsAgua_filtrada}
                                setRowsAgua={setRowsAgua}
                                setRowsAgua_filtrada={setRowsAgua_filtrada}
                            />

                            <FertilizacaoOrganicaForm
                                cabecalho={obj_anexo_cabecalho_selecionado}
                                obj_organica={obj_organica}
                                total_quant3={total_quant3}
                            />

                        </>
                        :
                        <></>
                }
            </main>
        </div>
    );
}